import { FiChevronLeft, FiChevronRight, FiCheckCircle } from "react-icons/fi";

interface FooterActionsProps {
  currentStep: number;
  totalSteps: number;
  canGoNext: boolean;
  loading: boolean;
  accentColor: string;
  textColor: string;
  backgroundColor?: string;
  onBack: () => void;
  onNext: () => void;
}

function FooterActions({
  currentStep,
  totalSteps,
  canGoNext,
  loading,
  accentColor,
  textColor,
  backgroundColor,
  onBack,
  onNext,
}: FooterActionsProps) {
  return (
    <div className="border-t border-stroke bg-white px-4 sm:px-6 py-4 dark:border-strokedark dark:bg-boxdark">
      <div className="flex gap-3">
        {currentStep > 1 && (
          <button
            type="button"
            onClick={onBack}
            className="flex items-center justify-center gap-2 rounded-xl border-2 border-stroke px-6 py-3.5 sm:py-4 text-sm font-semibold text-black transition hover:bg-gray-50 dark:border-strokedark dark:text-white dark:hover:bg-meta-4"
          >
            <FiChevronLeft size={18} />
            <span className="hidden sm:inline">Voltar</span>
          </button>
        )}

        {currentStep < totalSteps ? (
          <button
            type="button"
            onClick={onNext}
            disabled={!canGoNext}
            className="flex-1 flex items-center justify-center gap-2 rounded-xl py-3.5 sm:py-4 text-sm sm:text-base font-semibold text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:opacity-90"
            style={{ backgroundColor: backgroundColor || accentColor, color: textColor }}
          >
            <span>Próximo</span>
            <FiChevronRight size={18} />
          </button>
        ) : (
          <button
            type="submit"
            disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 rounded-xl py-3.5 sm:py-4 text-sm sm:text-base font-semibold text-white transition-all disabled:opacity-50 shadow-lg hover:opacity-90"
            style={{ backgroundColor: backgroundColor || accentColor, color: textColor }}
          >
            {loading ? (
              <>
                <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" />
                <span>Confirmando...</span>
              </>
            ) : (
              <>
                <FiCheckCircle size={18} />
                <span>Confirmar Agendamento</span>
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
}

export default FooterActions;
